;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('filterStatusDropdown', filterStatusDropdown)

  /* @ngInject */
  function filterStatusDropdown () {
    return {
      restrict: 'E',
      scope: {
        params: '=',
        showFilterButton: '<',
        defaultStatusList: '<'
      },
      templateUrl: '/core/directives/core-filters/dropdowns/filter-status-dropdown/filter-status-dropdown-directive.html?$$REVISION$$',
      controller: 'FilterStatusDropdownController'
    }
  }
})()
